import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import { truncateText, formatTime, getData, apiUrl } from "../util";
class Files extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      dates: null,
      dateData: null,
      date: null,
      urls: null,
      url: null,
      urlData: null,
    };
  }
  componentDidMount() {
    const { date, all } = this.props.match.params;
    if (date === "urls") {
      getData(`${apiUrl}/getUrls`).then(json => {
        if (all) {
          const url = decodeURIComponent(all).replace(
            "payment?destination=https://www.washingtonpost.com",
            "payment?destination=https:%2F%2Fwww.washingtonpost.com"
          );
          this.setState({
            urls: json.urls,
            url,
            urlData: json.urls[url],
          });
        } else {
          this.setState({
            urls: json.urls,
          });
        }
      });
      return;
    }
    getData(`${apiUrl}/getDates`).then(json => {
      if (date) {
        this.setState({
          dates: json.dates,
          date: date,
          dateData: json.dates[date],
        });
      } else {
        this.setState({
          dates: json.dates,
        });
      }
    });
  }
  render() {
    const { dates, dateData, date, urls, urlData } = this.state;
    const { user } = this.props;
    const showAll = this.props.match.params.all;
    if (!user) {
      return (
        <Redirect
          to={{ pathname: "/", state: { from: this.props.location } }}
        />
      );
    }
    if (urls && !urlData) {
      const sortedUrls = Object.keys(urls).sort((a, b) => {
        return a <= b ? 1 : -1;
      });
      return (
        <>
          <h1>Files by URL</h1>
          <p>
            <b>
              <Link to="/files">List by date</Link>
            </b>
          </p>
          {sortedUrls.map(url => {
            return (
              <p key={url}>
                <Link to={`/files/urls/${encodeURIComponent(url)}`}>{url}</Link>
              </p>
            );
          })}
        </>
      );
    }
    if (urls && urlData) {
      urlData.sort((a, b) => {
        return a.ctime > b.ctime ? -1 : 1;
      });
      return (
        <>
          {urlData.map(data => (
            <p key={data.id}>
              <Link to={`/ss/${data.id}/${data.ctime}`}>
                {truncateText(data.url, 80)}
              </Link>{" "}
              <br />
              Ran <b>{data.runCount}</b> times at <b>{data.ctime}</b>{" "}
              {data.hasSplitTest ? "🔀" : ""} {data.isMobile ? "📱" : ""}{" "}
              {data.flagSplit ? "⚠️" : "✅"}
            </p>
          ))}
        </>
      );
    }
    if (dates && !dateData) {
      const sortedDates = Object.keys(dates).sort((a, b) => {
        return a <= b ? 1 : -1;
      });
      return (
        <>
          <h1>Files by date</h1>
          <p>
            <b>
              <Link to="/files/urls">List by file</Link>
            </b>
          </p>
          {sortedDates.map(date => {
            return (
              <p key={date}>
                <Link to={`/files/${date}`}>{date}</Link>
              </p>
            );
          })}
        </>
      );
    } else if (dateData) {
      let onlySplits;
      if (!showAll) {
        onlySplits = dateData.filter(data => {
          return data.hasSplitTest;
        });
      }

      const dateDataDisplay = showAll ? dateData : onlySplits;

      dateDataDisplay.sort((a, b) => {
        return a.ctime > b.ctime ? -1 : 1;
      });

      return (
        <>
          <h1>{date}</h1>
          <p>
            {showAll ? (
              <b>
                Showing all: <Link to={`/files/${date}`}>show just splits</Link>
                .
              </b>
            ) : (
              <b>
                Showing just splits ( 🔀):{" "}
                <Link to={`/files/${date}/all`}>show all</Link>.
              </b>
            )}
          </p>
          {dateDataDisplay.map(data => (
            <p key={data.id}>
              <Link to={`/ss/${data.id}/${data.ctime}`}>
                {truncateText(data.url, 80)}
              </Link>{" "}
              <br />
              Ran <b>{data.runCount}</b> times at{" "}
              <b>{formatTime(data.ctime)}</b> {data.hasSplitTest ? "🔀" : ""}{" "}
              {data.isMobile ? "📱" : ""}{" "}
              {data.flagSplit ? (
                <span title="Maybe not a real split test">⚠️</span>
              ) : (
                <span title="Probably a real split test">✅</span>
              )}
            </p>
          ))}
        </>
      );
    } else {
      return <h1>Loading...</h1>;
    }
  }
}

export default Files;
